import clsx from 'clsx';
import React from 'react';
import TimeDurationIcon from '../../assets/icons/time-duration-icon.svg?react';
import TextArea from '../TextArea';
import FileInput from '../FileInput';
import Button from '../Button';
import { toggleModal } from '../../reducers/modalToggle';
import { useDispatch } from 'react-redux';
import { useButtonSizeSmall } from '../../utils/buttonSizes';

interface RequestDueDateExtensionModalProps {
  otherClasses?: string;
  formHandler: any;
}

const RequestDueDateExtensionModal: React.FC<
  RequestDueDateExtensionModalProps
> = ({ otherClasses, formHandler }) => {
  const requestDueDateExtensionModalClasses = clsx(otherClasses, 'w-full');

  const dispatch = useDispatch();

  return (
    <div
      className={requestDueDateExtensionModalClasses}
      data-testid="request-due-date-extension-modal"
    >
      <div className="flex flex-col items-center gap-2.5 text-center">
        <TimeDurationIcon className="[&>path]:fill-brand-papery h-85 w-85" />
        <h4 className="text-brand-papery">Request Due Date Extension</h4>
        <p className="font-inter-variable text-brand-papery -tracking-text-area text-base leading-5 font-normal lg:text-lg">
          You can request an extension on the due date from the manager who has
          assigned this corrective action to you.
        </p>
      </div>
      <form
        action="#"
        onSubmit={formHandler?.handleSubmit}
        className="mt-12 flex flex-col"
      >
        <TextArea
          name="description"
          onBlur={formHandler?.handleBlur}
          onChange={formHandler?.handleChange}
          value={formHandler?.values?.description}
          placeholder="Write something here e.g. the specified corrective action requires an extra week to complete..."
          disabled={formHandler?.isSubmitting}
          errorMessage={
            formHandler?.touched.description && formHandler?.errors.description
              ? formHandler?.errors.description
              : ''
          }
          label="Description*"
          otherClasses={{ container: 'w-full mb-6' }}
        />
        <FileInput
          label="Attachments (Optional)"
          name="files"
          selectedFiles={formHandler?.values?.files}
          onChange={(e) => formHandler?.setFieldValue('files', e, true)}
          updateAccept
          accept={{
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg'],
            'video/mp4': ['.mp4'],
            'image/gif': ['.gif'],
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              ['.docx'],
            'video/quicktime': ['.mov'],
            'video/hevc': ['.hevc'],
          }}
          customPlaceholder={{
            label1:
              'Max 3 files allowed, Image size 5mb and video size 50mb allowed.',
            label2: '.png, .jpg/.jpeg, .gif, .mp4, .pdf, .doc, .docx',
            label3: 'Upload Files',
          }}
          onBlur={formHandler?.handleBlur}
          errorMessage={
            formHandler?.errors?.files ? formHandler?.errors?.files : ''
          }
        />
        <div className="mt-12 flex w-full flex-col-reverse gap-x-6 gap-y-15 md:grid md:grid-cols-2">
          <Button
            onClick={() => {
              dispatch(toggleModal(''));
              formHandler?.resetForm();
            }}
            type="button"
            variant="secondary"
            disable={formHandler?.isSubmitting}
            otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink "
            size={useButtonSizeSmall()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            size={useButtonSizeSmall()}
            otherClasses="bg-brand-papery hover:text-brand-papery hover:border-brand-papery "
          >
            Request Extension
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RequestDueDateExtensionModal;
